<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="8">
						<el-form-item label="产品">
							<el-select v-model="searchParams.pid" clearable @change="chgPro"
								placeholder="请选择">
								<el-option v-for="item in productList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="">
							<el-checkbox @change="list" v-model="searchParams.noteam">显示未分配团队</el-checkbox>
						</el-form-item>
					</el-col>
					<div class="search-btn">
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator"> 
			<el-button type="primary"  v-has-permission-code-and="'002000150000'" size="mini" icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" size="mini"  v-has-permission-code-and="'002000150005'"  icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="name" label="迭代名称"></el-table-column>
				<el-table-column prop="pName" width="220" label="所属产品"></el-table-column>
				<el-table-column prop="startTime" width="200" label="周期">
					<template slot-scope="props">
						<el-tag size="mini" type="success"> {{ props.row.startTime }} </el-tag>
						~ <el-tag size="mini" type="danger"> {{ props.row.endTime }} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="state" width="80" label="状态"></el-table-column>
				<el-table-column prop="progress" width="80" label="进度">
					<template slot-scope="props">
						{{ props.row.progress == null ? 0 : props.row.progress }}%
					</template>
				</el-table-column>
				<el-table-column prop="allManDay" width="120" label="已用人日/计划">
					<template slot-scope="props">
						{{ props.row.otherManDay?props.row.otherManDay.toFixed(1):0 }}/{{ props.row.allManDay }}
					</template>

				</el-table-column>
				 
				<el-table-column prop="tName" width="200" label="团队"></el-table-column>
				<el-table-column prop="post" width="90" label="我的角色"></el-table-column>

				<el-table-column label="操作" fixed="right" width="260">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini"  v-has-permission-code-and="'002000150000'" v-if="isShow(scope.row.post)"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" type="danger"  v-has-permission-code-and="'002000150000'"  v-if="isShow(scope.row.post)"
								@click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/sprint/sprint/sprint.js';
import productApi from "@/api/product/product/product.js";
export default {
	name: 'sprint',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			productList: [], //装载迭代的数据
			me: {}
		};
	},
	methods: {
 
		chgPro(){
			this.$caches.pid.set(this.searchParams.pid);
                  this.list()
		},isShow(actor){


			if('ad' == this.me.role ){
                      return true
			 }

                
                   if(actor && 'SM' == actor){
                      return true
			 }
		 

		    return false
		},
		//获取数据
		list() {

			this.productList = this.$caches.products.get();
			if (!this.productList) {
				//获取产品数据并存入productData
				productApi.list4Select({}, response => {
					this.productList = response.data;
					this.$caches.products.set(this.productList);
				})
			}

			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			console.log("paramslist", params);

			api.list2(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({productId:this.searchParams.pid}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id,
				tName:row.tName
			};
			this.$refs.edit.open(editParameter,  '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id,
				tName:row.tName
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			//this.page.current = 1;// = new this.$constant.pageObj();
			this.list();
		},
		//清空搜索框
		clearSearch() {
			this.searchParams = {};
			this.list();
		}
	},
	mounted() {

		let selectProd = this.$caches.pid.get();
		if (selectProd) {
			this.searchParams = { pid: selectProd }
		}
		this.me = this.$caches.user.get();
		console.log("this.me     ", this.me)

		this.list()
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
